import styled, { css } from 'styled-components';

import { Typography } from '@/components/Typography';

export const SectionHeader = styled(Typography)<{
  $color: string;
  disableGutters?: boolean;
  sizeDesktop: number;
  sizeMobile: number;
}>`
  text-transform: uppercase;
  word-break: break-word;
  white-space: unset;

  ${({
    $color,
    disableGutters,
    sizeDesktop,
    sizeMobile,
    textAlign,
    theme,
  }) => css`
    font-size: ${sizeMobile}px;
    font-family: ${theme.fontFamilies.italianPlate};
    font-weight: ${theme.fontWeights.bold};
    color: ${$color};
    text-align: ${textAlign || 'left'};

    ${!disableGutters &&
    css`
      margin-bottom: ${theme.spacing(3)};
      ${theme.media.md.up} {
        margin-bottom: ${theme.spacing(4)};
      }
    `}

    ${theme.media.md.up} {
      font-size: ${sizeDesktop}px;
    }
  `}
`;

export const Title = styled.span`
  ${({ theme }) => css`
    color: ${theme.colors.primary};
    background-image: linear-gradient(
      ${theme.colors.primary},
      ${theme.colors.primary}
    );
    background-clip: text;
    -webkit-background-clip: text;
    text-shadow: none;
  `}
`;
